/**
 * Calculates the number of elapsed days between two dates, rounding up.
 * Returns a minimum of 1 so same-day loans display as "1 day".
 *
 * @param startDate - The loan start date (typically `created_at`).
 * @param endDate - The end date to measure against. Defaults to `new Date()`.
 * @returns An integer number of days (always >= 1).
 */
export function calcLoanDurationDays(startDate: Date, endDate: Date = new Date()): number {
  return Math.max(1, Math.ceil((endDate.getTime() - startDate.getTime()) / 86400000));
}
